import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { InventoryActionEnum, MetalTypeEnum, TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetPendingInventoryTransactionListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingInventoryTransactionListingAttempt', handleGetPendingInventoryTransactionListing, api);
}

function* handleGetPendingInventoryTransactionListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            branchCode,
            productId,
            action,
            status,
            dateFrom,
            dateTo,
            metalType,
        },
    } = reduxState.approval.pendingInventoryTransactionListing;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingInventoryTransactionListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getInventoryTransactionListing], {
        authToken,
        index,
        productId: productId !== 0 ? productId : undefined,
        action: action ? UtilFunctions.Misc.getEnumValueByKey(InventoryActionEnum, action.split(' ').join('')) : undefined,
        status: status ? UtilFunctions.Misc.getEnumValueByKey(TransactionStatusEnum, status) : undefined,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
        metalType: metalType ? metalType : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingInventoryTransactionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingInventoryTransactionListingSuccess(response.data));
    }
}
